import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppBar, Avatar, Box, Divider, IconButton, Menu, MenuItem, Toolbar, Typography } from "@mui/material";
import CoreChangePasswordModal from "./CoreChangePasswordModal";

const Topbar = ({ isCollapsed, onToggleSidebar, isMobile }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const email = localStorage.getItem("userEmail") || "";

  const closeMenu = () => setAnchorEl(null);

  return (
    <AppBar
      position="fixed"
      sx={{ backgroundColor: "white", borderBottom: "1px solid #dcdcdc", boxShadow: "none", zIndex: 1201 }}
    >
      <Toolbar className="toolbar-main" sx={{ display: "flex", justifyContent: "space-between", paddingLeft: "6px !important" }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <IconButton onClick={onToggleSidebar} sx={{ color: "black" }}>
            <ion-icon
              name={isMobile ? "menu-outline" : isCollapsed ? "chevron-forward-outline" : "chevron-back-outline"}
              style={{ fontSize: "24px" }}
            ></ion-icon>
          </IconButton>
          <Typography sx={{ ml: 1, fontWeight: 700, color: "black" }}>Administrador Axium</Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton
            color="primary"
            onClick={(event) => setAnchorEl(event.currentTarget)}
            sx={{ width: 46, height: 46, borderRadius: "50%", flex: "0 0 46px", "&:hover": { borderRadius: "50%" } }}
          >
            <Avatar sx={{ width: 37, height: 37, bgcolor: "transparent", color: "primary.main" }}>
              <ion-icon name="person-circle-outline" style={{ fontSize: "37px" }}></ion-icon>
            </Avatar>
          </IconButton>
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu} sx={{ mt: "30px" }}>
            <Box sx={{ px: 2, py: 1.25, minWidth: 240 }}>
              <Typography variant="body2" color="text.secondary" noWrap>{email}</Typography>
            </Box>
            <Divider />
            <MenuItem onClick={() => { closeMenu(); setPasswordModalOpen(true); }}>Cambiar contraseña</MenuItem>
            <MenuItem onClick={() => { closeMenu(); navigate("/logout"); }}>Cerrar sesión</MenuItem>
          </Menu>
        </Box>
      </Toolbar>

      <CoreChangePasswordModal open={passwordModalOpen} onClose={() => setPasswordModalOpen(false)} />
    </AppBar>
  );
};

export default Topbar;
